import { memo } from "react";
import { cn, formatCurrency } from "@/lib/utils";
import { Typography } from "../../Typography";

export type PriceDisplayProps = {
  price: number | null;
  salePrice?: number;
  priceColor?: string;
  salePriceColor?: string;
  className?: string;
  unit?: string;
};

const PriceDisplay = ({
  price,
  salePrice,
  priceColor = "text-caption",
  salePriceColor = "text-secondary",
  className,
  unit,
}: PriceDisplayProps) => {
  const numPrice = Number(price) || 0;
  const numSalePrice =
    typeof salePrice === "number" ? salePrice : Number(salePrice);
  const hasDiscount =
    Boolean(numSalePrice) && numSalePrice > 0 && numSalePrice < numPrice;

  const displayPrice = hasDiscount ? numSalePrice : numPrice;
  const resolvedSalePriceColor =
    salePriceColor === "primary"
      ? "text-primary"
      : salePriceColor === "secondary"
        ? "text-secondary"
        : salePriceColor;

  return (
    <div
      className={cn(
        "flex min-w-0 flex-col justify-end text-right h-auto",
        className,
      )}
    >
      {/* price */}
      {hasDiscount && (
        <Typography
          variant="body-xs"
          className={cn("truncate line-through", priceColor)}
        >
          {formatCurrency(numPrice)}
        </Typography>
      )}

      {/* sale price */}
      <Typography
        variant="subtitle1"
        className={cn("truncate font-semibold", resolvedSalePriceColor)}
      >
        {formatCurrency(displayPrice)}
        {unit ? <span className="font-semibold">{unit}</span> : null}
      </Typography>
    </div>
  );
};

export default memo(PriceDisplay);
